<template>
  <div class="home">
    <div class="pc_home_page">
      <div style="max-width: 1200px;margin: auto">
        <supplyChainIntro></supplyChainIntro>

        <div class="ai-banner">
          <div class="banner-png">
            <img width="400px" src="../assets/images/ai_pic.png" alt />
          </div>

          <div class="ai-banner-content">
            <div class="ai-title">
              供应链公司、贸易公司的成败就在
              <span class="ai-em">风控</span>
            </div>
            <div class="ai-greeting">请输入企业名称，开始 AI 智能风控分析</div>
            <div class="ai-search-row">
              <div class="ai-search-box">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" class="ai-search-icon">
                  <circle cx="6.8" cy="6.8" r="5" stroke="#A8BECE" stroke-width="1.5" />
                  <line
                    x1="10.8"
                    y1="10.8"
                    x2="14"
                    y2="14"
                    stroke="#A8BECE"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                </svg>
                <input
                  v-model="searchVal"
                  type="text"
                  placeholder="请输入企业名称"
                  @keyup.enter="onSearch"
                />
              </div>
              <button class="ai-search-btn" @click="onSearch">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path
                    d="M7 1L8.6 5.2H13.2L9.8 7.8L11.1 12.2L7 9.6L2.9 12.2L4.2 7.8L0.8 5.2H5.4L7 1Z"
                    fill="white"
                  />
                </svg>
                AI 智能筛查
              </button>
            </div>
          </div>

          <!-- 最近访问 -->
          <div class="recent-card">
            <div class="recent-head">
              <div class="recent-title">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="8" cy="8" r="6.5" stroke="#3E8FFF" stroke-width="1.4" />
                  <polyline
                    points="8,4.5 8,8.5 11,10.5"
                    stroke="#3E8FFF"
                    stroke-width="1.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                最近访问
              </div>
            </div>
            <div class="recent-grid">
              <div v-for="(item, i) in recentList" :key="i" class="recent-item">
                <div>
                  <div class="recent-name">{{ item.name }}</div>
                  <div class="recent-date">{{ item.date }}</div>
                </div>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path
                    d="M5 3L9 7L5 11"
                    stroke="#C0D0E8"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>

        <div class="introduce">
          <div class="logo-box">
            <div class="logo-scroll" @mouseenter="stopScroll" @mouseleave="startScroll">
              <div class="logo-item" v-for="(item, i) in logos" :key="i">
                <img :src="item.url" alt />
              </div>
            </div>
          </div>
        </div>

        <div class="content" style="margin: 40px 0 20px;">
          <div class="content-module headlines">
            <div class="title">大宗商品供应链风控必须掌握行情数据</div>
          </div>
        </div>
        <futuresData></futuresData>
      </div>

      <div class="content">
        <div class="content-module headlines">
          <div class="title">软件产品与智能体联动</div>
          <div class="apps-list">
            <div class="item-box" v-for="(item, i) in apps" :key="i">
              <div class="icon">
                <span class="iconfont" :class="['icon-' + item.icon]"></span>
              </div>
              <div class="name">{{ item.name }}</div>
              <div class="desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import futuresData from "./components/futures-data";
import indexCard from "./components/indexCard";
import supplyChainIntro from './components/supplyChainIntro'
import { appList } from '../utils/optionData'
export default {
  name: "home",
  components: { futuresData, indexCard, supplyChainIntro },
  data() {
    return {
      searchVal: "",
      recentList: [
        { name: "深圳市****有限公司", date: "今天" },
        { name: "东莞****股份有限公司", date: "今天" },
        { name: "惠州****科技有限公司", date: "昨天" },
        { name: "广州****有限公司", date: "昨天" }
      ],
      apps: appList,
      logos: [
        { url: require("../assets/img/logo/ljjt.png") },
        { url: require("../assets/img/logo/scgt.png") },
        { url: require("../assets/img/logo/fjjg.png") },
        { url: require("../assets/img/logo/scwm.png") },
        // { url: require('../assets/img/logo/stk.png') },
        { url: require("../assets/img/logo/yhyz.png") },
        { url: require("../assets/img/logo/szg.png") },
        { url: require("../assets/img/logo/sdny.png") },
        { url: require("../assets/img/logo/sfsy.png") },
        { url: require("../assets/img/logo/szdwm.png") },
        { url: require("../assets/img/logo/cqwjm.png") }
      ]
    };
  },
  mounted() {
    this.share();
  },
  methods: {
    onSearch() {
      window.open("http://scp.zhongpukeji.cn/#/login");
    },
    // 鼠标移入：暂停
    stopScroll() {
      document.querySelector(".logo-scroll").style.animationPlayState =
        "paused";
    },
    // 鼠标移出：继续
    startScroll() {
      document.querySelector(".logo-scroll").style.animationPlayState =
        "running";
    },
    share() {
      this.$http({
        url: this.$http.adornUrl("/crmapi/wechat/share/get"),
        method: "get",
        params: {
          url: location.href
        }
      }).then(res => {
        console.log("分享数据获取：", res);
        let resData = res.data.result || {};
        let that = this;
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: resData.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
          timestamp: resData.timestamp, // 必填，生成签名的时间戳
          nonceStr: resData.nonceStr, // 必填，生成签名的随机串
          signature: resData.signature, // 必填，签名，见附录1
          jsApiList: [
            "checkJsApi",
            "onMenuShareTimeline",
            "updateAppMessageShareData",
            "onMenuShareQQ",
            "onMenuShareWeibo",
            "onMenuShareQZone",
            "hideMenuItems",
            "showMenuItems",
            "hideAllNonBaseMenuItem",
            "showAllNonBaseMenuItem",
            "translateVoice",
            "startRecord",
            "stopRecord",
            "onVoiceRecordEnd",
            "playVoice",
            "onVoicePlayEnd",
            "pauseVoice",
            "stopVoice",
            "uploadVoice",
            "downloadVoice",
            "chooseImage",
            "previewImage",
            "uploadImage",
            "downloadImage",
            "getNetworkType",
            "openLocation",
            "getLocation",
            "hideOptionMenu",
            "showOptionMenu",
            "closeWindow",
            "updateTimelineShareData",
            "scanQRCode",
            "chooseWXPay",
            "openProductSpecificView",
            "addCard",
            "chooseCard",
            "openCard"
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });

        wx.ready(function() {
          let shareUrl = location.href;
          let logo = "http://www.zhongpukeji.cn/img/icon/logo.png";
          let title =
            "深圳海平创新公司致力于推动全球贸易与供应链服务行业数字化创新";
          let desc = "";
          wx.updateTimelineShareData({
            title, // 分享标题
            desc, // 分享描述
            link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: logo, // 分享图标
            success: function(res) {
              console.log(
                "分享回调updateTimelineShareData：",
                JSON.stringify(res)
              );
            }
          });
          //分享给好友
          wx.updateAppMessageShareData({
            title, // 分享标题
            desc, // 分享描述
            link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: logo, // 分享图标
            success: function(res) {
              console.log(
                "分享回调updateAppMessageShareData：",
                JSON.stringify(res)
              );
            }
          });
        });
        wx.error(function(res) {
          console.log("打印错误消息:", res.errMsg); //打印错误消息。及把 debug:false,设置为debug:ture就可以直接在网页上看到弹出的错误提示
        });
      });
    }
  }
};
</script>

<style lang="scss">
.top-title {
  font-family: "huaweihongmengcuti";
  font-size: 40px;
  text-align: center;
  padding: 70px;
}

.pictrue-group {
  margin: auto;
  padding: 4px 0;
  max-width: 1200px;

  img {
    margin: 0;
    padding: 0;
    display: block;
  }
}


/* ---- 左侧节点（竖线串联）---- */
.so-left {
  width: 34%;
  position: relative;
  z-index: 1;
}

.so-timeline {
  position: relative;
  padding-left: 40px;

  /* 竖线 */
  &::before {
    content: '';
    position: absolute;
    left: 5px;
    top: 18px;
    bottom: 18px;
    width: 2px;
    background: linear-gradient(
      to bottom,
      transparent 0%,
      rgba(0, 184, 148, 0.25) 8%,
      rgba(0, 184, 148, 0.45) 50%,
      rgba(0, 184, 148, 0.25) 92%,
      transparent 100%
    );
    border-radius: 1px;
  }
}

.so-node {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 0;
  position: relative;
  transition: transform 0.25s;

  &:hover {
    transform: translateX(3px);

    .so-dot-ball {
      background: #00b894;
      box-shadow: 0 0 0 4px rgba(0, 184, 148, 0.15);
    }

    .so-h-line {
      background: rgba(0, 184, 148, 0.5);
    }
  }
}

/* 竖线上的实心圆点 */
.so-dot-ball {
  position: absolute;
  left: -40px;     /* padding-left=40px, dot中心对齐竖线(left=5px) */
  top: 28px;       /* 对齐图标中心位置 */
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #fff;
  border: 2px solid #00b894;
  z-index: 2;
  transition: background 0.25s, box-shadow 0.25s;
}

/* 圆点到图标的水平连线 */
.so-h-line {
  position: absolute;
  left: -28px;
  top: 32px;
  width: 22px;
  height: 1.5px;
  background: rgba(0, 184, 148, 0.3);
  transition: background 0.25s;
}

/* anchor 占位容器 */
.so-node-anchor {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 0;
  pointer-events: none;
}

.so-node-icon {
  flex-shrink: 0;
  margin-top: 4px;
}

.so-node-title {
  font-size: 15px;
  font-weight: 700;
  color: #1a2b3c;
  margin-bottom: 7px;
}

.so-node-desc {
  font-size: 12px;
  color: #6b7d8e;
  line-height: 1.7;
}

/* ---- 中间 Logo 区 ---- */
.so-center {
  width: 24%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
}

.so-rings {
  position: relative;
  width: 250px;
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.so-logo-wrap {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: linear-gradient(135deg, #f1f8fd 0%, #dceffc 50%, #d4f0e6 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  box-shadow: 0 6px 30px rgba(0, 184, 148, 0.15), 0 0 0 1px rgba(0, 184, 148, 0.08);

  img {
    width: 56px;
    height: 56px;
    object-fit: contain;
  }
}

.so-center-label {
  margin-top: 20px;
  font-size: 20px;
  font-weight: 700;
  color: #0f293e;
  letter-spacing: 5px;
}

/* ---- 旋转环 ---- */
.so-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 50%;
  pointer-events: none;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

.so-ring-1 {
  width: 150px;
  height: 88px;
  margin: -44px 0 0 -75px;
  border: 1.5px solid rgba(14, 165, 233, 0.3);
  animation-name: spinRing1;
  animation-duration: 6s;
}

.so-ring-2 {
  width: 192px;
  height: 112px;
  margin: -56px 0 0 -96px;
  border: 1.2px solid rgba(14, 165, 233, 0.2);
  animation-name: spinRing2;
  animation-duration: 9s;
}

.so-ring-3 {
  width: 228px;
  height: 132px;
  margin: -66px 0 0 -114px;
  border: 1px solid rgba(14, 165, 233, 0.14);
  animation-name: spinRing1;
  animation-duration: 14s;
  animation-direction: reverse;
}

.so-ring-4 {
  width: 248px;
  height: 248px;
  margin: -124px 0 0 -124px;
  border-radius: 50%;
  border: 1px dashed rgba(14, 165, 233, 0.15);
  animation-name: spinRing3;
  animation-duration: 22s;
}

/* ---- 装饰圆点 ---- */
.so-dot {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}

.so-dot-1 {
  top: 10px;
  left: 50%;
  width: 6px;
  height: 6px;
  margin-left: -3px;
  background: #00b894;
  opacity: 0.45;
}

.so-dot-2 {
  bottom: 20px;
  right: 12px;
  width: 5px;
  height: 5px;
  background: #00b894;
  opacity: 0.35;
}

.so-dot-3 {
  top: 48%;
  left: -6px;
  width: 6px;
  height: 6px;
  background: #00b894;
  opacity: 0.3;
}

.so-dot-4 {
  top: 32%;
  right: -4px;
  width: 4px;
  height: 4px;
  background: #00b894;
  opacity: 0.4;
}

.so-dot-5 {
  bottom: 28%;
  left: 14px;
  width: 4px;
  height: 4px;
  background: #00b894;
  opacity: 0.35;
}

.so-dot-6 {
  top: 14px;
  right: 28px;
  width: 5px;
  height: 5px;
  background: #00b894;
  opacity: 0.38;
}

/* 橙色强调圆点 */
.so-dot-orange {
  top: 62%;
  right: 20px;
  width: 7px;
  height: 7px;
  background: #00b894;
  opacity: 0.55;
  animation: dotPulse 2.5s ease-in-out infinite;
}

@keyframes dotPulse {
  0%, 100% { opacity: 0.35; transform: scale(1); }
  50% { opacity: 0.75; transform: scale(1.4); }
}

/* ---- 旋转动画 ---- */
@keyframes spinRing1 {
  0% {
    transform: rotateY(0deg) rotateZ(0deg) rotateX(65deg);
  }
  100% {
    transform: rotateY(360deg) rotateZ(360deg) rotateX(65deg);
  }
}

@keyframes spinRing2 {
  0% {
    transform: rotateY(0deg) rotateZ(0deg) rotateX(52deg);
  }
  100% {
    transform: rotateY(-360deg) rotateZ(360deg) rotateX(52deg);
  }
}

@keyframes spinRing3 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.so-expert-title {
  font-size: 15px;
  font-weight: 700;
  color: #1a2b3c;
  margin-bottom: 22px;
  text-align: center;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.so-accent-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #00b894;
  opacity: 0.7;
}

.so-expert-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.so-avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: rgba(14, 165, 233, 0.04);
  border: 1.5px solid #d4e8f6;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.25s;

  &:hover {
    border-color: #00b894;
  }
}

.so-expert-name {
  font-size: 14px;
  font-weight: 600;
  color: #1a2b3c;
  text-align: center;
  white-space: nowrap;
}

.so-expert-role {
  font-size: 11px;
  color: #95a5b0;
  text-align: center;
}

.so-slogan {
  font-size: 13px;
  font-weight: 600;
  color: #1a2b3c;
  text-align: center;
  letter-spacing: 2px;
}

/* ========== 服务能力总览 响应式 ========== */
@media screen and (max-width: 1200px) {
  .so-center{
    width: 100%;
  }
}

/* AI 搜索横幅 */
.ai-banner {
  margin-top: 50px;
  border-radius: 14px;
  overflow: hidden;
  position: relative;
  min-height: 248px;
  box-shadow: 0 1px 6px rgba(30, 60, 120, 0.1);
}

.banner-png {
  position: absolute;
  right: 0;
  top: -20px;
  bottom: -45px;
  width: 420px;
  pointer-events: none;
  overflow: hidden;
}

.ai-banner-content {
  position: relative;
  z-index: 1;
  padding: 48px 36px;
  max-width: 800px;
}

.ai-greeting {
  font-size: 14px;
  color: #4a6590;
  margin-bottom: 8px;
}

.ai-title {
  font-size: 22px;
  font-weight: 700;
  color: #1a2b4a;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.ai-em {
  color: #1b56ff;
  font-style: italic;
  font-weight: 800;
  letter-spacing: 1px;
}

.ai-search-row {
  display: flex;
  gap: 10px;
}

.ai-search-box {
  flex: 1;
  background: rgba(255, 255, 255, 0.92);
  border: 1.5px solid rgba(120, 165, 255, 0.4);
  border-radius: 8px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 9px;

  .ai-search-icon {
    flex-shrink: 0;
  }

  input {
    border: none;
    background: transparent;
    font-size: 13px;
    color: #333;
    width: 100%;
    outline: none;
    font-family: inherit;

    &::placeholder {
      color: #b8c8dc;
      font-size: 13px;
    }
  }
}

.ai-search-btn {
  background: #1b56ff;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 11px 24px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 7px;
  white-space: nowrap;
  box-shadow: 0 4px 14px rgba(27, 86, 255, 0.38);
  font-family: inherit;
  transition: background 0.2s, box-shadow 0.2s;

  &:hover {
    background: #1446ee;
    box-shadow: 0 6px 18px rgba(27, 86, 255, 0.48);
  }
}

/* 最近访问 */
.recent-card {
  background: #fff;
  border-radius: 0 0 12px 12px;
  padding: 18px 22px;
  box-shadow: 0 1px 6px rgba(30, 60, 120, 0.07);
}

.recent-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.recent-title {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 14px;
  font-weight: 600;
  color: #2d3d5a;
}

.recent-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.recent-item {
  border: 1px solid #e8eef6;
  border-radius: 8px;
  padding: 14px 16px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: border-color 0.2s, background 0.2s;

  &:hover {
    border-color: #a8c8ff;
    background: #f7faff;
  }
}

.recent-name {
  font-size: 13px;
  font-weight: 500;
  color: #2d3d5a;
  margin-bottom: 5px;
}

.recent-date {
  font-size: 12px;
  color: #a0b4d0;
}

.introduce {
  padding: 10px 20px 10px;
  margin-top: 20px;
  background: #fff;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  .introduce-item {
    width: 36%;
    font-size: 1.7rem;
    margin: 10px 0;
    font-family: "huaweihongmengcuti";

    span {
      color: #e7000b;
    }

    i {
      padding-right: 4px;
      color: #1296db;
    }
  }
}

.chance_wrap {
  padding: 10px 20px 10px;
  background: #fff;

  .el-col {
    height: 24rem;
    margin-top: 10px;
  }

  // background: url('../assets/img/home/chance.jpg');
  // background-size: 100% auto;
  .hover:hover {
    transform: translateY(-4px) scale(1.005);
    /* 上移6px并放大到1.05倍 */
    box-shadow: 0 10px 20px -2px rgba(0, 0, 0, 0.15),
      0 10px 10px -5px rgba(0, 0, 0, 0.05);
  }

  .hover {
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .top-module {
    background: #fff;
    box-shadow: 0 0 6px -1px rgba(0, 0, 0, 0.1);
    padding: 10px;
    height: 100%;
    box-sizing: border-box;

    .product-list {
      display: flex;
      flex-wrap: wrap;

      .product-item {
        width: calc(33.33% - 6px);
        box-sizing: border-box;
        height: 2.1rem;
        border: 3px solid #9bf2fd;
        border-radius: 15px;
        line-height: 1.9rem;
        font-size: 0.9rem;
        padding: 0 0 0 0.6rem;
        margin: 0 6px 1.2rem 0;
        box-shadow: 5px 15px 20px 0 #bbd2f3;

        .iconfont {
          color: #1296db;
          font-size: 1.2rem;
          vertical-align: -0.1em;
        }
      }
    }

    .top-module-content {
      padding-top: 20px;

      .picture {
        img:last-child {
          margin-right: 0;
        }

        img {
          width: calc(50% - 10px);
          height: 5rem;
          margin-right: 10px;
        }
      }

      .content-title {
        font-size: 1rem;
        text-align: center;
        color: #c6611c;
      }

      .peixun {
        font-size: 1rem;
        color: #000;
        line-height: 1.6rem;
      }

      .tip {
        color: #888;
        font-size: 0.8rem;
        line-height: 16px;
        margin-top: 0.2rem;
      }

      .ruanjian:first-child {
        margin-top: 0;
      }

      .ruanjian {
        font-size: 1.1rem;
        text-align: center;
        margin-top: 0.6rem;
        padding: 0.4rem 0;

        .desc {
          font-size: 0.8rem;
          color: #888;
        }
      }

      .ruanjian-content {
        display: flex;
        flex-wrap: wrap;

        .item {
          width: calc(50% - 0.6rem);
          text-align: center;
          background: #f3f4f6;
          border-radius: 4px;
          margin: 0.6rem 0.6rem 0 0;
          font-size: 1rem;
          padding: 0.4rem 0;
        }
      }

      .expert {
        display: flex;
        margin-bottom: 10px;

        .photo {
          width: 90px;
          height: 90px;
          border-radius: 50%;

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }

        .expert-intro {
          padding: 20px;

          .name {
            font-size: 1.2rem;
            font-weight: bold;
            color: #1296db;
          }

          .intro {
            font-size: 1rem;
          }
        }
      }

      .identity {
        display: flex;
        color: #3a3a3a;
        font-size: 0.95rem;
        line-height: 2rem;

        .iconfont {
          padding-right: 10px;
          color: #1296db;
          vertical-align: -0.2em;
        }
      }
    }

    .title {
      background: linear-gradient(to right, #d4e5fe, #f1f1f1);
      padding: 1.2rem 0.7rem;
      font-size: 24px;
      font-weight: bold;
      border-radius: 10px;
      position: relative;
      margin-top: 0.6rem;

      .iconfont {
        font-size: 2rem;
        color: #1296db;
      }

      .text {
        position: relative;
        z-index: 3;
      }

      .number {
        position: absolute;
        font-size: 6.2rem;
        font-family: "huaweihongmengziti", Arial, Helvetica, sans-serif;
        bottom: -10px;
        right: 10px;
        z-index: 0;
        background-image: -webkit-linear-gradient(
          top,
          #1296db 0,
          #d4e5fe 60%,
          #f1f1f1 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-style: italic;
      }
    }
  }

  .text_1 {
    font-size: 3rem;
    font-weight: bold;
    text-align: center;
    letter-spacing: 3px;
  }

  .btn_1 {
    width: 260px;
    cursor: pointer;
    margin: auto;
    text-align: center;
    background: #1d74ff;
    height: 38px;
    line-height: 38px;
    color: #fff;
    margin-top: 20px;
    border-radius: 4px;
    margin-bottom: 30px;
  }

  .notice {
    padding-top: 10px;
    color: #00b541;

    span {
      font-size: 1.2rem;
    }
  }

  .class_wrap {
    display: flex;
    padding: 10px 0;

    .goods_name {
      width: 80px;
      text-align: right;
    }

    i {
      font-size: 3rem;
      // color: #3874F6;
    }
  }

  .weixin-code {
    width: 160px;

    img {
      width: 100%;
    }

    p {
      font-size: 0.8rem;
      color: #333;
      text-align: center;
    }
  }
}

.achievement-statistics {
  width: 1200px;
  margin: 20px auto 0;
  text-align: center;

  .iconfont {
    font-size: 3rem;
    color: #787878;
  }

  .number {
    font-size: 3rem;
    color: #1d74ff;
    margin: 10px 0;
  }

  .name {
    font-size: 1rem;
    color: #333;
  }
}

.main {
  // background-color: #000;
}

/* 可视区域：固定宽度，隐藏溢出 */
.logo-box {
  width: 100%;
  overflow: hidden;
  margin: 40px 0;
}

/* 滚动条：会自动无限滚动 */
.logo-scroll {
  display: flex;
  width: max-content;
  animation: logoMove 15s linear infinite;
}

/* 每个item：固定宽度！保证可视区域一排5个 */
.logo-item {
  /* 这里是关键！给一个固定宽度，不要用百分比 */
  // width: 180px;  /* 你可以自己调大小 140px、160px都行 */
  // padding: 0 10px;
  margin: 0 40px;
  box-sizing: border-box;
}

.logo-item img {
  width: auto;
  height: 60px;
  display: block;
  object-fit: contain;
}

/* 从右向左滚动动画 */
@keyframes logoMove {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(calc(-180px * 8));
  }
}

.main-container {
  margin: auto;
  padding: 4px 0;
  max-width: 1200px;
  display: flex;
}

.product_list {
  width: 21%;
  height: 632px;
  padding: 1px;
}

.product {
  background-color: #fff;
  padding: 2px 4px 2px 12px;

  .item {
    display: flex;
    margin: 20px 0;

    .icon {
      padding: 4px 8px 0 0;

      img {
        width: 28px;
        height: 28px;
      }
    }

    .t {
      font-size: 1rem;
      line-height: 24px;
      color: #222222;
    }

    .m {
      font-weight: 290;
      font-size: 0.8rem;
      line-height: 12px;
      color: #888888;
      margin-top: 9px;
    }

    .b {
      font-weight: 290;
      font-size: 0.8rem;
      line-height: 12px;
      color: #1d74ff;
      margin-top: 9px;
    }
  }
}

.main_pictrue {
  width: 60%;
  padding: 1px;

  .advert {
    display: flex;

    div:first-child {
      width: 33.4%;
    }

    div {
      width: 33.3%;
      height: 170px;
      padding: 1px;
      box-sizing: border-box;
    }
  }

  .ad1 {
    width: 100%;
    height: 460px;
    padding: 1px;
    box-sizing: border-box;
  }

  img {
    width: 100%;
    height: 100%;
    border-radius: 2px;
  }
}

.login_wrap {
  width: 19%;
  padding: 1px;

  .login {
    padding: 1px;

    .box {
      height: 260px;
      width: 100%;
      background-color: #fff;
      border-radius: 2px;
      text-align: center;
      padding: 20px;
      box-sizing: border-box;
    }

    p {
      font-weight: 290;
      font-size: 0.8rem;
      line-height: 12px;
      color: #888888;
      line-height: 40px;
      margin-bottom: 20px;
    }
  }

  .login_btn {
    span {
      display: inline-block;
      margin: 0 6px;
      padding: 0 10px;
      height: 28px;
      border-radius: 4px;
      font-weight: 290;
      font-size: 1rem;
      line-height: 26px;
      cursor: pointer;
    }

    .phone-login-btn {
      display: none;
    }

    .login-primany {
      background-color: #1d74ff;
      border: 1px solid #1d74ff;
      color: #fff;
    }

    span:last-child {
      border: 1px solid #1d74ff;
      color: #1d74ff;
    }
  }

  .photo {
    padding: 1px;

    div {
      height: 190px;
      width: 100%;
      border-radius: 2px;
      background-color: #fff;
      background-image: url(../assets/img/home/card.png);
      background-size: 100% auto;
      background-position: 0 5px;
      background-repeat: no-repeat;
      font-weight: bold;
      font-size: 0.8rem;
      line-height: 24px;
      text-align: center;
      padding-top: 145px;
      box-sizing: border-box;

      span {
        display: inline-block;
        width: 140px;
        height: 30px;
        line-height: 30px;
        background: linear-gradient(to right, #6bceff, #34ffcc);
        color: #fff;
        border-radius: 15px;
        cursor: pointer;
      }
    }
  }

  .relation {
    padding: 1px;

    div {
      width: 100%;
      height: 174px;
      border-radius: 2px;
      background: url(../assets/img/home/relation.png) center 0;
      font-weight: bold;
      font-size: 0.8rem;
      line-height: 24px;
      color: #333;
      text-align: center;
      padding-top: 150px;
      box-sizing: border-box;
    }
  }
}

.content {
  // background: #000;
}

.content-module {
  max-width: 1200px;
  margin: auto;
  padding: 0 0 40px 0;

  .title {
    font-size: 32px;
    font-weight: bold;
    line-height: 40px;
    text-align: center;
    color: #222222;
  }

  .en-title {
    font-family: "huaweihongmengziti", Roboto;
    font-size: 1.2rem;
    line-height: 20px;
    text-align: center;
    color: #888888;
    margin-top: 24px;
  }
}

.headlines {
  padding: 20px 0;
  box-sizing: content-box;

  .news-list {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;

    .item {
      border: 1px solid #eeeeee;
      box-sizing: border-box;
      box-shadow: 0px 8px 8px 4px rgba(221, 221, 221, 0.1);
      border-radius: 8px;
      width: 32%;
      height: 470px;
      cursor: pointer;

      .img {
        position: relative;
      }

      .date {
        position: absolute;
        bottom: 0;
        right: 0;
        line-height: 32px;
        color: #fff;
        padding-right: 18px;
        width: 100%;
        border-radius: 0 0 8px 8px;
        text-align: right;
        background: rgba(0, 0, 0, 0.2);
        box-sizing: border-box;

        img {
          vertical-align: -0.6em;
        }
      }

      .top-img {
        width: 100%;
        height: 249px;
        border-radius: 8px;
      }

      .text {
        padding: 30px;
      }

      .new-title {
        font-size: 1.2rem;
        line-height: 36px;
        letter-spacing: -0.05em;
        color: #222222;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }

      .new-title:hover {
        color: #0078ff;
      }

      .new-content {
        font-size: 1.2rem;
        line-height: 28px;
        letter-spacing: -0.06em;
        color: #555555;
        margin-top: 18px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }

      .tags {
        margin-top: 20px;

        img {
          width: 16px;
          height: 16px;
        }

        span {
          display: inline-block;
          border: 1px solid #f4f4f4;
          box-sizing: border-box;
          border-radius: 4px;
          font-weight: 290;
          font-size: 0.8rem;
          line-height: 16px;
          color: #888888;
          padding: 2px 6px;
          margin-left: 12px;
          margin-top: 4px;
        }
      }
    }
  }

  .apps-list {
    display: flex;
    flex-wrap: wrap;
    background: #f8f9fd;
    margin-top: 40px;
    padding: 0 20px 20px;

    .item-box:nth-child(4n) {
      margin-right: 0;
    }

    .item-box {
      width: 23.5%;
      height: 215px;
      margin-top: 24px;
      margin-right: 2%;
      box-sizing: border-box;
      background: #fff;
      padding: 26px 20px 45px 20px;
      color: #000;

      .name {
        font-size: 1.3rem;
        font-weight: 600;
        margin: 30px 0;
      }

      .desc {
        font-size: 1rem;
        letter-spacing: 2px;
        color: #888;
      }

      .icon {
        width: 40px;
        height: 40px;
        overflow: hidden;
        border-radius: 50%;
        background: #ecf0f6;
        text-align: center;
        line-height: 40px;
        font-size: 24px;
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .home {
    font-size: 1.3rem;

    .identity {
      font-size: 1.2rem !important;
    }

    .product-list {
      .product-item {
        font-size: 1.3rem !important;
        height: 2.25rem !important;

        .iconfont {
          font-size: 1.6rem !important;
        }
      }
    }

    .top-module {
      .title {
        font-size: 1.5rem !important;
      }

      .peixun {
        font-size: 1.2rem !important;
        line-height: 1.9rem !important;
      }
    }

    .notice {
      span {
        font-size: 1.6rem !important;
      }
    }

    .introduce-item {
      font-size: 1.8rem !important;
    }
  }

  .text-table .el-table .el-table__cell {
    padding: 0.9rem 0 !important;
    font-size: 1.6rem !important;
  }

  .ruanjian {
    font-size: 1.2rem !important;
    padding: 0.5rem 0 !important;
  }

  .ruanjian-content {
    .item {
      font-size: 1.1rem !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue